import React from 'react';
import { useTranslation } from 'react-i18next';
import { Url } from '@wix/da-url';
import PromoBanner from '@wix/da-ds/pkg/PromoBanner';
import TierBadge from '@wix/da-ds/pkg/Badges/TierBadge';
import { BiEventType, ReferralType } from '@wix/da-bi/pkg/constants';
export var StripTierPromotion = function (_a) {
    var _b;
    var className = _a.className, deviation = _a.deviation;
    var t = useTranslation().t;
    var showPromotion = ((_b = deviation === null || deviation === void 0 ? void 0 : deviation.extended) === null || _b === void 0 ? void 0 : _b.showStageMonetizationPromo) === 'tier';
    if (!showPromotion || !deviation.author) {
        return null;
    }
    return (React.createElement(PromoBanner, { className: className, size: "small", variant: "subscription", icon: React.createElement(TierBadge, { size: 16 }), messageAfterIcon: t('deviationview.artstage.tierPromotion.body'), ctaLabel: t('deviationview.artstage.tierPromotion.button.subscribe'), ctaHref: Url.userSubscriptionsPath({
            username: deviation.author.username,
        }), ctaBiData: {
            evid: BiEventType.VIEW_SUBSCRIPTION_TAB,
            typeid: deviation.typeId,
            itemid: deviation.deviationId,
            referral_info: ReferralType.ART_STAGE_PROMOTION,
        } }));
};
StripTierPromotion.displayName = 'StripTierPromotion';
export default StripTierPromotion;
//# sourceMappingURL=StripTierPromotion.js.map